export default "__VITE_ASSET__DfeqEhwI__"